import { Paper, Typography, Box } from '@material-ui/core'
import React from 'react'

import { gregorianToJalaali } from '../../../helpers/date'
import { getTranslate, lang } from '../../../localization'
import { useStyles } from './styles/AllocateInfo.styles'

interface Props {
  email: string
  name: string
  requested: number
  success: number
  failed: number
  allocationDate: string
}

const AllocateInfo: React.FC<Props> = ({
  email,
  allocationDate,
  failed,
  name,
  requested,
  success
}) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root} elevation={0}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate(name)}
          </Typography>
          <Typography className={classes.value}>{email}</Typography>
        </Box>
        <Box className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Allocate Date')}
          </Typography>
          <Typography className={classes.value}>
            {lang === 'fa'
              ? gregorianToJalaali(allocationDate)
              : allocationDate}
          </Typography>
        </Box>
        <Box className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Allocate Number')}
          </Typography>
          <Typography className={classes.value}>{requested}</Typography>
        </Box>
        <Box className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Success')}
          </Typography>
          <Typography className={classes.value}>{success}</Typography>
        </Box>
        <Box className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Failed')}
          </Typography>
          <Typography className={classes.value}>{failed}</Typography>
        </Box>
      </Box>
    </Paper>
  )
}

export default AllocateInfo
